import { render, staticRenderFns } from "./AppControlSetting.vue?vue&type=template&id=a56a9bce&scoped=true"
import script from "./AppControlSetting.vue?vue&type=script&lang=js"
export * from "./AppControlSetting.vue?vue&type=script&lang=js"
import style0 from "./AppControlSetting.vue?vue&type=style&index=0&id=a56a9bce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a56a9bce",
  null
  
)

export default component.exports